var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-content-center align-items-end page-footer"},[_c('p',{staticClass:"page-footer-txt"}),_c('div',[_vm._v("\n        © 2023 Ascentra Credit Union. | \n        All Rights Reserved | \n        Federally Insured by NCUA | \n        Equal Housing Opportunity\n      ")]),_c('p')])
}]

export { render, staticRenderFns }